import {Placeholder} from '../../../placeholder'
import {useSelectContext} from '../../../select/context'
import {useSearchContext} from '../../../search_input'
import {SearchEmpty} from '../../../../hooks/use_search'

const placeholderProps = {
	animation: 'hourglass',
	name: 'list_picker_default',
	subtitle: false,
	size: 'small',
	buttonLayoutProps: {
		width: 'full',
		padding: '0 8',
	},
	layoutProps: {
		width: 'full',
		minWidth: 200,
		background: 'white',
		margin: 'auto',
		padding: '32 8',
	},
}

export const SelectEmptyList = ({emptyPlaceholderProps = {}}) => {
	const {items} = useSelectContext()
	const {search, handleClear} = useSearchContext()

	if (items.length) return null

	if (search) return <SearchEmpty action={handleClear} />

	return <Placeholder {...placeholderProps} {...emptyPlaceholderProps} />
}
